export default "__VITE_ASSET__Dqt_VTXu__"